import moment from 'moment/moment';
import i18n from '@/i18n';
import { OPENNED, ARCHIVED, CANCELED } from '@/configuration/signatureElectronique/signatureElectroniqueConf';
import nomPrenomGetter from '@/services/general/nomPrenomGetter';
import formatDate from '@/services/general/formatDate';

function getLatestSignature(signatures, etat, propriete) {
  const sortedSignatures = signatures
    .filter(signature => signature.contratEtatSignature === etat)
    .sort((a, b) => moment(b[propriete]).diff(a[propriete]));
  return sortedSignatures[0];
}

export default function getInfosSignaturePourDevisCommande(signatures) {
  if (!signatures.length) return {};
  const info = {
    iconColor: null,
    message: null,
  };
  const signature = signatures.find(signature => {
    return signature.contratEtatSignature === OPENNED;
  });
  if (signature) {
    info.iconColor = 'is-warning';
    info.message = {
      libelle: i18n.t('detail.signatureElectronique.messageDemandeEnvoyee'),
      dateEnvoi: formatDate(signature.dateEnvoie),
      initiateur: signature.utilisateur ? nomPrenomGetter(signature.utilisateur) : i18n.t('general.inconnu'),
    };
    return info;
  }

  if (signatures.some(signature => signature.contratEtatSignature === ARCHIVED)) {
    info.iconColor = 'is-success';
    const lastSignatureArchivee = getLatestSignature(signatures, ARCHIVED, 'dateSignature');
    info.message = {
      libelle: i18n.t('detail.signatureElectronique.messageDemandeValidee'),
      dateSignature: formatDate(lastSignatureArchivee.dateSignature),
      initiateur: lastSignatureArchivee.utilisateur ? nomPrenomGetter(lastSignatureArchivee.utilisateur) : i18n.t('general.inconnu'),
      dateEnvoi: formatDate(lastSignatureArchivee.dateEnvoie),
    };
    return info;
  }

  if (signatures.some(signature => signature.contratEtatSignature === CANCELED)) {
    const lastSignatureAnnulee = getLatestSignature(signatures, CANCELED, 'lastModificationTime');
    info.iconColor = 'is-danger';
    info.message = {
      libelle: i18n.t('detail.signatureElectronique.messageDemandeAnnulee'),
      dateSignature: formatDate(lastSignatureAnnulee.dateSignature),
      initiateur: lastSignatureAnnulee.utilisateur ? nomPrenomGetter(lastSignatureAnnulee.utilisateur) : i18n.t('general.inconnu'),
      dateEnvoi: formatDate(lastSignatureAnnulee.dateEnvoie),
    };
    return info;
  }
  return {};
}
